export enum PeriodEnum {
  First = 'firstHalf',
  Second = 'secondHalf',
  ExtraFirst = 'extraTimeFirstHalf',
  ExtraSecond = 'extraTimeSecondHalf',
  Penalties = 'penalties',
  End = 'end'
}
